import { catchError, of, Subject } from 'rxjs';
import { webSocket } from 'rxjs/webSocket';
import { onCreateFactoryAuth } from '../system/auth';
import { createUserModel } from './userInfo';
const strToArrayBuffer = (str) => {
    const array = new Uint8Array(str.length);
    for (let i = 0; i < str.length; i++) {
        array[i] = str.charCodeAt(i);
    }
    return array.buffer;
};
const arrayBufferToStr = (arrayBuffer) => {
    const uint8_msg = new Uint8Array(arrayBuffer);
    const decodedString = String.fromCharCode.apply(null, uint8_msg);
    return decodedString;
};
export class WebSocket {
    constructor(channelUrl, type) {
        //用户数据
        this.UserInfo = createUserModel();
        this.Auth = onCreateFactoryAuth();
        this.openObserver = new Subject();
        this.timeout = 30000; //30秒
        this.heartCheck = {
            reset: () => {
                //接收成功一次推送，就将心跳检测的倒计时重置为30秒
                clearTimeout(WebSocket.timeoutObj); //重置倒计时
                this.heartCheck.start();
            },
            stop: () => {
                clearTimeout(WebSocket.timeoutObj);
            },
            start: () => {
                //启动心跳检测机制，设置倒计时30秒一次
                WebSocket.timeoutObj = setTimeout(() => {
                    const message = {
                        type: 'PING',
                        data: {
                            token: this.Auth.AccessToken,
                            liveId: this.UserInfo.liveId,
                            sourceCode: 'b415e203-4e8d-11ed-995c-0242ac110002',
                        },
                    };
                    this.onSend(message); //启动心跳
                }, this.timeout);
            },
        };
        if (!WebSocket.subject) {
            WebSocket.subject = webSocket({
                url: `wss://${location.host}/livews/subscribe`,
                // url: 'ws://pcsd-live-reception.earth.xpaas.lenovo.com/subscribe',
                // url: 'ws://10.112.63.42:8180/subscribe',
                binaryType: 'arraybuffer',
                openObserver: {
                    next: (e) => {
                        this.heartCheck.start();
                    },
                },
                closeObserver: {
                    next: (e) => {
                        this.heartCheck.stop();
                    },
                },
                //接受消息
                deserializer: function (e) {
                    return JSON.parse(arrayBufferToStr(e.data));
                },
                //发送给服务器
                serializer: function (value) {
                    return strToArrayBuffer(JSON.stringify(value));
                },
            });
        }
        this.observable = WebSocket.subject
            .multiplex(() => ({
            type: 'PING',
            data: {
                token: this.Auth.AccessToken,
                liveId: this.UserInfo.liveId,
                sourceCode: 'b415e203-4e8d-11ed-995c-0242ac110002',
            },
        }), //subMsg
        () => ({
            type: 'PING',
            data: {
                token: this.Auth.AccessToken,
                liveId: this.UserInfo.liveId,
                sourceCode: 'b415e203-4e8d-11ed-995c-0242ac110002',
            },
        }), //unsubMsg
        (message) => {
            this.heartCheck.reset();
            return message.type == type;
        })
            .pipe(catchError((error) => {
            WebSocket.subject = null;
            return of('error', error);
        }));
    }
    onSend(data) {
        if (WebSocket.subject) {
            WebSocket.subject.next(data);
        }
    }
}
WebSocket.timeoutObj = null;
